var _excluded = ["handleAddressSelect", "placementId", "surfaceId", "onTagClose", "onClear", "options"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { Input, Adornment, Button, AdornedInput } from '@zillow/constellation';
export var PLACEHOLDER_TEXT = 'Enter your home address';

var SearchInputWithButton = function SearchInputWithButton(_ref) {
  var handleAddressSelect = _ref.handleAddressSelect,
      placementId = _ref.placementId,
      surfaceId = _ref.surfaceId,
      onTagClose = _ref.onTagClose,
      onClear = _ref.onClear,
      options = _ref.options,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(AdornedInput, {
    input: /*#__PURE__*/React.createElement(Input // id={undefined} prevents chrome autocomplete display
    , _extends({
      id: undefined,
      "data-testid": "address-search-input",
      placeholder: PLACEHOLDER_TEXT
    }, props)),
    rightAdornment: /*#__PURE__*/React.createElement(Adornment, {
      "aria-hidden": "false"
    }, /*#__PURE__*/React.createElement(Button, {
      name: "submit-button",
      type: "submit",
      size: "sm",
      buttonType: "primary",
      style: {
        paddingLeft: '20px',
        paddingRight: '20px'
      },
      onClick: function onClick() {
        var _options$;

        return handleAddressSelect({
          zpid: (_options$ = options[0]) === null || _options$ === void 0 ? void 0 : _options$.id,
          placementId: placementId,
          surfaceId: surfaceId
        });
      }
    }, "Get started"))
  });
};

export default SearchInputWithButton;
//# sourceMappingURL=SearchInputWithButton.js.map